module.exports = __webpack_public_path__ + "static/media/halo-auto.cd7e68ba.webp";